import React, { useState, useEffect } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps { 
    selectedTemplateName: string;
    fieldInfo: IFieldData;
}

const GridDefaultFieldValue = ({ selectedTemplateName, fieldInfo }: IProps) => {
    const [defaultFieldValue, setDefaultFieldValue] = useState(CQMasterDataStore.OutputConfig.getStoreKeyData(selectedTemplateName, 'defaultFieldValue'));
    const [selectedField, setSelectedField] = useState<string>('');
    const [defaultValue, setDefaultValue] = useState<string>('');
    const [showInputFields, setShowInputFields] = useState<boolean>(false);
  
    useEffect(() => {
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(selectedTemplateName, 'defaultFieldValue', defaultFieldValue);      
    }, [selectedField, defaultValue, defaultFieldValue]);

    const addDefaultFieldValue = (field: string, value: string) => {
        setDefaultFieldValue((field && value) ?
            {
                field: field,
                value: value,
            } : {}
        );
    };

    const jsonObj = JSON.stringify(defaultFieldValue);

    const deleteDefaultFieldValue = () => {
        addDefaultFieldValue('', '');
        setSelectedField('');
        setDefaultValue('');
    }

    return (
        <>
        {showInputFields ?
        <div className="slds-border_top">
            <h3 className="slds-text-heading_small slds-m-bottom_small slds-m-top_x-small">{fieldInfo.name}
                <div className="slds-float_right">
                    <button 
                        className="slds-button slds-button_neutral"
                        onClick={() => setShowInputFields(false)}
                    >Hide
                    </button>
                </div>
            </h3>
            <div className="slds-grid slds-grid_vertical-align-center">
                <div className="slds-col slds-size_6-of-12 slds-m-top_xx-small">
                    <div className="slds-form-element">
                        <label className="slds-form-element__label">Set {fieldInfo.name}</label>
                        <div className="slds-form-element__control">
                            <input
                                type="text"
                                placeholder="Enter the Field"
                                className="slds-input slds-m-top_x-small"
                                value={selectedField}
                                onChange={(e: any) => setSelectedField(e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="Enter Value"
                                className="slds-input slds-m-top_x-small"
                                value={defaultValue}
                                onChange={(e: any) => setDefaultValue(e.target.value)}
                            />
                            <button
                                className="slds-button slds-button_brand slds-m-top_x-small"
                                onClick={() => addDefaultFieldValue(selectedField, defaultValue)}
                            >Save
                            </button>
                        </div>
                    </div>
                </div>
                <div className="slds-col slds-size_6-of-12 slds-m-top_xx-small">
                    {defaultFieldValue.field && defaultFieldValue.value &&
                        <>
                            this.filterfieldAndValue = {jsonObj};
                            <button
                                className="slds-button slds-button_icon"
                                onClick={() => deleteDefaultFieldValue()}
                            ><i className="cq-icon-delete"></i>
                            </button>
                        </>
                    }
                </div>
            </div>
        </div> : 
        <button
            className="slds-button slds-button_brand"
            onClick={() => setShowInputFields(true)}
        >{`Add ${fieldInfo.name}`}
        </button>}
    </>
    );
}

export const GridComponentDefaultFieldValue = observer(GridDefaultFieldValue);
